import config from 'config';

export default !Number(config.org_id) ? '/organization-selection' : '/login';
